import type { EditableItem, EditableSection, EditableSectionValue } from './pageCms';

export function getText(section: EditableSection | undefined, key: string, fallback = '') {
  const value = section?.[key];
  return typeof value === 'string' ? value : fallback;
}

export function getTextList(section: EditableSection | undefined, key: string, fallback: string[] = []) {
  const value = section?.[key];
  return Array.isArray(value) && value.every((item) => typeof item === 'string') ? value as string[] : fallback;
}

export function getItems(section: EditableSection | undefined, key: string, fallback: EditableItem[] = []) {
  const value = section?.[key] as EditableSectionValue | undefined;
  return Array.isArray(value) && value.every((item) => item && typeof item === 'object' && !Array.isArray(item))
    ? value as EditableItem[]
    : fallback;
}

export function splitLines(value: string) {
  return value.split('\n').map((line) => line.trim()).filter(Boolean);
}
